<div class="custom-control custom-switch">
  <input
    [id]="identifier"
    [name]="name"
    type="checkbox"
    class="custom-control-input"
    [(ngModel)]="value"
    [placeholder]="placeholder"
    #control="ngModel"
    [required]="required == 'true' || required == '' ? '' : undefined"
    (blur)="onTouched()"
    [readonly]="readonly"
    [disabled]="disabled"
    [attr.aria-required]="isRequired"
    [attr.aria-describedby]="isShowErrors ? identifier + '-feedbacks' : null"
  />
  <label class="custom-control-label" [for]="identifier">
    {{ labelText }}
  </label>
  <small
    [id]="identifier + 'Help'"
    *ngIf="helpText"
    class="form-text text-muted"
  >
    {{ helpText }}</small
  >

  <ng-container *ngTemplateOutlet="feedback"> </ng-container>
</div>

<ng-template #feedback>
  <ng-container *ngIf="isShowErrors">
    <div [id]="identifier + '-feedbacks'" class="invalid-feedback" role="alert">
      <div
        *ngFor="let error of errors; trackBy: trackByMessageKey"
        [innerText]="
          key + '.' + error.messageKey | translate : error.messageArgs
        "
      ></div>
    </div>
  </ng-container>
</ng-template>
